import { Button, type ButtonProps, Icon, cn } from '@sr/ui-library';
import { forwardRef } from 'react';

/**
 * Back link for `PageHeader`'s `breadcrumb` slot: a muted, caption-sized link
 * with a leading chevron, sitting above the page title.
 *
 * The treatment is fixed here rather than spelled out at each call site so
 * every page's Back reads the same, in the same shape as `AppDropdownButton` —
 * `className` is still merged, so a caller can adjust spacing without
 * restating the styling.
 */
// eslint-disable-next-line react/display-name -- lint-backlog: anonymous forwardRef/memo component; add a displayName in a follow-up
export const BackButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children = 'Back', className, ...props }, ref) => (
    <Button
      className={cn(
        'gap-1.5 text-xs font-normal leading-4 text-muted-foreground hover:text-foreground',
        className,
      )}
      iconSize="sm"
      ref={ref}
      sectionLeft={<Icon icon="chevronLeft" />}
      size="content"
      variant="link"
      {...props}
    >
      {children}
    </Button>
  ),
);
